<template>
  <div style="display: inline">
    <!--<el-input :value="value" :disabled="true" @input="onShow" />-->
    <el-date-picker
      v-model="dateField"
      :disabled="disabled"
      type="date"
      style="width:130px;margin-left:10px"
      value-format="yyyy-MM-dd"
      @change="changeHandler('dateField')"
    />
    <el-input
      v-model="hourField"
      :disabled="disabled"
      type="number"
      :maxlength="2"
      style="width:50px;margin-left:10px"
      @change="changeHandler('hourField')"
    />
    <span style="margin-left:5px">:</span>
    <el-input
      v-model="minuteField"
      :disabled="disabled"
      type="number"
      :maxlength="2"
      style="width:50px;margin-left:5px"
      @change="changeHandler('minuteField')"
    />
    <el-input
      v-model="secondField"
      :disabled="disabled"
      type="number"
      :maxlength="2"
      style="width:100px;display: none;margin-left:10px"
      @change="changeHandler('secondField')"
    />
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import StrUtils from '@/utils/StrUtils'
export default {
  name: 'CargoDateTimeFieldInput',
  props: {
    value: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    relateOtherTime: { type: Boolean, default: true }
  },
  data() {
    return {
      selectedDate: null,
      dateField: null,
      hourField: '00',
      minuteField: '00',
      secondField: '00'
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.selectedDate) {
        this.onShow()
      }
    }
  },
  created() {
    this.onShow()
  },
  methods: {
    onShow() {
      this.selectedDate = this.value
      if (!StrUtils.isEmpty(this.value)) {
        const date = new Date(this.value)
        this.dateField = date
        this.hourField = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ''
        this.minuteField = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() + ''
        this.secondField = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + ''
      } else {
        this.dateField = null
        this.hourField = '00'
        this.minuteField = '00'
        this.secondField = '00'
      }
    },
    changeHandler(event) {
      // 日期为时空 ，清空时分秒
      if (!this.dateField) {
        this.hourField = '00'
        this.minuteField = '00'
        this.secondField = '00'

        this.selectedDate = null
        this.$emit('input', this.selectedDate)
        return
      }

      if (event === 'dateField' && this.relateOtherTime) {
        const now = new Date()
        this.hourField = now.getHours()
        this.minuteField = now.getMinutes()
        this.secondField = now.getSeconds()
      } else if (event === 'hourField') {
        if (!this.hourField) {
          this.hourField = '00'
        } else if (this.hourField.length === 1) {
          this.hourField = '0' + this.hourField
        } else {
          const value = parseInt(this.hourField.substring(0, 2))
          if (value < 0) {
            this.hourField = '00'
          } else if (value > 23) {
            this.hourField = '23'
          } else {
            this.hourField = this.hourField.substring(0, 2)
          }
        }
      } else if (event === 'minuteField') {
        if (!this.minuteField) {
          this.minuteField = '00'
        } else if (this.minuteField.length === 1) {
          this.minuteField = '0' + this.minuteField
        } else {
          const value = parseInt(this.minuteField.substring(0, 2))
          if (value < 0) {
            this.minuteField = '00'
          } else if (value > 59) {
            this.minuteField = '59'
          } else {
            this.minuteField = this.minuteField.substring(0, 2)
          }
        }
      }

      /* if (this.hourField === undefined || this.hourField === '') {
        this.hourField = 0
      }
      if (this.minuteField === undefined || this.minuteField === '') {
        this.minuteField = 0
      }*/
      const date = ColumnUtils.formateDateToString(this.dateField, 'yyyy-MM-dd') + ' ' + this.hourField + ':' + this.minuteField
      this.selectedDate = ColumnUtils.formateDateToString(date, 'yyyy-MM-dd hh:mm:ss')
      this.$emit('input', this.selectedDate)
    }
  }
}
</script>

<style>
</style>
